import withMetadataArgument from '../min/exports/withMetadataArgument.js'

import _format from '../es6/legacy/format.js'

export function format() {
	return withMetadataArgument(_format, arguments)
}



//////////////////
// WEBPACK FOOTER
// ./~/libphonenumber-js/index.es6.exports/format.js
// module id = 1148
// module chunks = 22